import React from "react";
import "./index.scss";
import api from "api";
import _ from "lodash";
import { useEffect } from "react";
import { useState } from "react";
import { connect } from 'react-redux';
import stateMap from "store/stateMap";
import LastSeen from "component/LastSeen";
import { ComponentConfigTagline } from "component/ConfigTagline";
import { AvatarGetPicture } from "component/Avatar";
import InitialsAvatar from 'react-initials-avatar';
import update from "immutability-helper";
import { FollowButton } from "component/Follow";
import { AvatarMessage } from "component/Avatar";
import 'react-initials-avatar/lib/ReactInitialsAvatar.css';

const ProfileBanner = connect(stateMap)((props) => {
    const [profile, setProfile]                     = useState(props.profile);
    const [TotalInvolved, setTotalInvolved]         = useState(false);
    const [TotalDone, setTotalDone]                 = useState(false);
    const [userRating, setUserRating]               = useState(false);
    const [Follower, setFollower]                   = useState(false);
    const [socmeds, setSocmeds]                     = useState([]);
    
    useEffect(() => {
        
        setProfile(props.profile);

    }, [props.profile])

    useEffect(() => {
        if(profile === false)
        {
            return;
        }

        api('/UserSocmeds', 'get', {
            user_id : profile.UserID
        }).then(response => {
            setSocmeds(response.accounts);
        });

        api('/Initiative', 'get', {
            get_total : 1, member_id : profile.UserID
        }).then(response => {
            setTotalInvolved(response.initiative);
        });

        api('/Initiative', 'get', {
            current_status : 'completed', get_total : 1, member_id : profile.UserID
        }).then(response => {
            setTotalDone(response.initiative);
        });

        api('/Profile/Rating', 'get', {
            user_id : profile.UserID
        }).then(response => {
            setUserRating(response.rating);
        });

        api('/Follow', 'get', {
            following : profile.UserID
            ,get_total : 1
        }).then(response => {
            setFollower(response.follow);
        });
        
    }, [profile]);
    
    return (
        <div className="user-header-banner">
            <div className="container">
                <div className="page-profile-wrapper color-white">
                    <div className="user-picture text-center">
                        {
                            profile != false  &&
                            <span className="image-box circle square">
                                {
                                    !profile.UserPhoto ? <InitialsAvatar name={profile.UserDisplayName} /> 
                                    : <img src={AvatarGetPicture(profile)} alt={ profile.UserDisplayName } />
                                }
                            </span>
                        }
                        <span className="text-xs">
                            {
                                profile == false ? <span className="skeleton"></span> :
                                <LastSeen user_id={profile.UserID}/>
                            }
                        </span>
                    </div>
                    <div className="user-information">
                        <h1 className="user-name leading-text">
                            {
                                profile == false ? <span className="skeleton"></span> :
                                <>{profile.UserDisplayName}</>
                            }
                        </h1>
                        <div className="mb-sm text-sm leading-text">
                            <div className="text-sm" dangerouslySetInnerHTML={{__html : profile.UserShortBio }}></div>
                            {
                                props.auth.user && props.auth.user.UserID == profile.UserID &&
                                <ComponentConfigTagline profile={profile} onChanged={(tagline) => {
                                    setProfile(
                                        update(profile, {
                                            UserShortBio : {
                                                $set : tagline
                                            }
                                        })
                                    )
                                }}/>
                            }
                        </div>
                        {
                            props.auth.user && 
                            <ul className="user-socmeds flex flex-wrap">
                                {
                                    socmeds.Behance && 
                                    <li className="user-socmed">
                                        <a href={socmeds.Behance} target="_blank" className="user-socmed-button">
                                            <img src={process.env.PUBLIC_URL + '/assets/socmed-icon/behance.svg'} alt="" />
                                            Behance
                                        </a>
                                    </li>
                                }
                                {
                                    socmeds.Twitter && 
                                    <li className="user-socmed">
                                        <a href={socmeds.Twitter} target="_blank" className="user-socmed-button">
                                            <img src={process.env.PUBLIC_URL + '/assets/socmed-icon/twitter.svg'} alt="" />
                                            Twitter
                                        </a>
                                    </li>
                                }
                                {
                                    socmeds.Instagram && 
                                    <li className="user-socmed">
                                        <a href={socmeds.Instagram} target="_blank" className="user-socmed-button">
                                            <img src={process.env.PUBLIC_URL + '/assets/socmed-icon/instagram.svg'} alt="" />
                                            Instagram
                                        </a>
                                    </li>
                                }
                                {
                                    socmeds.Website && 
                                    <li className="user-socmed">
                                        <a href={socmeds.Website} target="_blank" className="user-socmed-button">
                                            <img src={process.env.PUBLIC_URL + '/assets/socmed-icon/website.svg'} alt="" />
                                            Website
                                        </a>
                                    </li>
                                }
                                {
                                    socmeds.Deviantart &&
                                    <li className="user-socmed">
                                        <a href={socmeds.Deviantart} target="_blank" className="user-socmed-button">
                                            <img src={process.env.PUBLIC_URL + '/assets/socmed-icon/deviantart.svg'} alt="" />
                                            Deviantart
                                        </a>
                                    </li>
                                }
                            </ul>
                        }
                        <ul className="user-stats flex flex-wrap">
                            <li className="user-stat">
                                <div className="user-stat-wrapper text-center">
                                    <span className="value">
                                        {
                                            Follower === false ? <span className="skeleton"></span>:
                                            <>{Follower}</>
                                        }
                                    </span>
                                    <h2 className="label text-xs block">Follower</h2>
                                </div>
                            </li>
                            <li className="user-stat">
                                <div className="user-stat-wrapper text-center">
                                    <span className="value">
                                        {
                                            TotalInvolved === false ? <span className="skeleton"></span>:
                                            <>{TotalInvolved}</>
                                        }
                                    </span>
                                    <h2 className="label text-xs block">Involved Initative</h2>
                                </div>
                            </li>
                            <li className="user-stat">
                                <div className="user-stat-wrapper text-center">
                                    <span className="value">
                                    {
                                        userRating === false ? <span className="skeleton"></span>:
                                        <>{userRating.toString().padEnd(3,'.0')}</>
                                    }
                                    </span>
                                    <h2 className="label text-xs block">Rating</h2>
                                </div>
                            </li>
                            <li className="user-stat">
                                <div className="user-stat-wrapper text-center">
                                    <span className="value">
                                        {
                                            TotalDone === false ? <span className="skeleton"></span>:
                                            <>{TotalDone}</>
                                        }
                                    </span>
                                    <h2 className="label text-xs block">Initative Done</h2>
                                </div>
                            </li>
                        </ul>
                        {
                            props.auth.user && props.auth.user.UserID != profile.UserID &&
                            <div className="profile-banner-actions mt-md flex flex-wrap">
                                <div>
                                    <AvatarMessage user={profile} className="btn btn-mini btn-white btn-reverse"/>&nbsp;
                                    
                                </div>
                                <div>
                                    <FollowButton user={profile} className="btn btn-mini btn-white btn-reverse"/>

                                </div>
                            </div>

                        }
                    </div>
                </div>
            </div>
        </div>
    )
});

export default ProfileBanner;